import React, { Component } from 'react';

import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, change } from 'redux-form';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import { ActiveFreeze, CancelFreezeConfirmation } from '.';
import Heading from '../Heading/Heading';
import { ConfirmationWindow } from '../../lib/forms';

import PhoneNumberFormat from '../../lib/phoneNumber/PhoneNumberFormat';
import { products, Auth } from '../../services';

class FreezeForm extends Component {
  constructor() {
    super();
    this.state = {
      data: '',
     };
  }
  componentDidMount() {
    const { rest, setFreezeStatus, setFreezes } = this.props;
    const ProductId = rest.computedMatch.params.userProductId;
    products.getFreezes(rest.computedMatch.params.userProductId)
      .then((res) => {
        setFreezes(res.body.data.productFreeze);
        if (res.body.data.productFreeze) {
          this.props.changeFieldValue("start", res.body.data.productFreeze.start)
        }
      }).catch(error => {
      });
    products.getProduct(ProductId)
    .then(res => {
      setFreezeStatus(res.body.data.userProduct.Data.hasFutureFreeze, res.body.data.userProduct.Data.isFrozen)
        this.setState({
          data: res.body.data.userProduct.Data
        })
        if (res.body.data.userProduct.Data.hasFutureFreeze || res.body.data.userProduct.Data.isFrozen) {
          return
        }
         this.props.changeFieldValue("start", res.body.data.userProduct.Data.nextBillingDate)
      })
  }
   handleKeyPress = (e) => {
   if (e.key === 'Enter') {
     e.preventDefault();

   }
 }
  convertSelectedDateFromDatePicker(date) {
    return typeof date === 'string' ? date : moment(date).format('DD/MM/YYYY');
  }
  render(){
    const { translate, handleSubmit, cancel, form, error, values, freeze, cancelFreeze } = this.props;
    const { data } = this.state;
    const nextMonth = values.start ? values.start : data.nextBillingDate;
    const dayAfterNextBillingDate = moment(`${nextMonth}`).add(1, 'd')
    let message = translate('freeze-the-line')
    let startDate
    let endDate
    if (freeze.isFrozen) {
      startDate = null
      endDate = values.end === "option2" ? this.convertSelectedDateFromDatePicker(values.endField) : null  ;
      message = values.end === "option2" ? translate('update-ongoing-freeze') : translate('cancel-ongoing-freeze')
    } else if (freeze.hasFutureFreeze) {
       startDate = moment(values.start, 'YYYY-MM-DD').format('DD/MM/YYYY')
       endDate = values.end ? this.convertSelectedDateFromDatePicker(values.end) : `${translate('without-stopping')}`;
       message = translate('update-upcoming-freeze')
    } else {
       startDate = moment(values.start, 'YYYY-MM-DD').format('DD/MM/YYYY')
       endDate = values.end ? values.end : `${translate('without-stopping')}`
    }
    return (
      <div className="service-action" >
        <div className="card card-service-action">
          <div className="card-block">
            {Heading(translate('freeze-request'),PhoneNumberFormat(data.phoneNumber))}
            <div className="card card-service-action">
              <div className="mispari-card-block">
            <form className="form-group  edit" onSubmit={handleSubmit} onKeyPress={this.handleKeyPress} >
              {error && <p className="text-danger" role="alert">{error}</p>}

              <ActiveFreeze
                startDate={freeze.freezes ? freeze.freezes.start : null}
                endDate={freeze.freezes ? freeze.freezes.end : null}
                isFrozen={freeze.isFrozen}
                hasFutureFreeze={freeze.hasFutureFreeze}
                translate={translate}
                nextBillingDate={data.nextBillingDate}
                dayAfterNextBillingDate={dayAfterNextBillingDate}
                cancel={cancel}
                category={data.category}
              />
              <ConfirmationWindow message={message} startDate={startDate} endDate={endDate} phoneNumber={PhoneNumberFormat(data.phoneNumber)} />
              <CancelFreezeConfirmation message={translate('do-you-want-cancel-freeze-confirmation-message')} cancelFreeze={cancelFreeze} />
            </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    )
  }
}
const viewMapStateToProps = (state) => {

    return {
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      form: state.form,
      freeze: state.Freeze,
      values: getFormValues('Freeze')(state) ||{},
    }

}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
    setFreezes: (freezes) => {
      dispatch(
        {
          type: 'SET_FREEZES',
          freezes: freezes
        }
      );
    },

    setFreezeStatus: (hasFutureFreeze, isFrozen) => {
      dispatch(
        {
          type: 'SET_FREEZE_STATUS',
          hasFutureFreeze: hasFutureFreeze,
          isFrozen: isFrozen
        }
      );
    },
    changeFieldValue: (field, value) => {
      dispatch(
        change('Freeze', field, value)
      );
    },
  };
};

FreezeForm = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(FreezeForm);

 FreezeForm = reduxForm({
  form: 'Freeze',
})(FreezeForm)

class FreezeFormHandler extends Component {

  handleSubmit(values) {
    const {  rest, history, setFlashMessage, translate, freeze } = this.props;
    const ProductId = rest.computedMatch.params.userProductId;
    if (freeze.hasFutureFreeze) {
      const end = values.end ?  moment(values.end, 'DD/MM/YYYY') : null;
      return products.updateFreeze(ProductId, values.start, end)
      .then(res => {
        setFlashMessage(`${translate('changes-saved-successfully')}`, true)
        history.goBack()
        })
        .catch((error) => {
          if (error.status === 401) {
            Auth.logOut();
          } else if (error.body.errors[0]) {
            this.props.setFlashMessage("error", false)
            if (error.body.errors[0]) {
              if ( error.body.errors[0].code) {
                this.props.setFlashMessage(error.body.errors[0].code, false)
              }
            }
          }
        })
    } else if (freeze.isFrozen) {
      const end = values.end === "option2" ? values.endField : moment().format('DD/MM/YYYY') ;
      return products.updateFreeze(ProductId, freeze.freezes.start, end)
      .then(res => {
        setFlashMessage(`${translate('changes-saved-successfully')}`, true)
        history.goBack()
        })
        .catch((error) => {
          if (error.status === 401) {
            Auth.logOut();
          } else if (error.body.errors[0]) {
            this.props.setFlashMessage("error", false)
            if (error.body.errors[0]) {
              if ( error.body.errors[0].code) {
                this.props.setFlashMessage(error.body.errors[0].code, false)
              }
            }
          }
        })
    }

    return products.freezeProduct(ProductId, values)
    .then(res => {
      setFlashMessage(`${translate('changes-saved-successfully')}`, true)
      history.goBack()
      })
      .catch((error) => {
        if (error.status === 401) {
          Auth.logOut();
          return
        }else if (error.body.errors[0]) {
          this.props.setFlashMessage("error", false)
          if (error.body.errors[0]) {
            if ( error.body.errors[0].code) {
              this.props.setFlashMessage(error.body.errors[0].code, false)
            }
          }
        }
      })
    }
   cancel(values) {
     const { history } = this.props;
     history.goBack();
   }
   cancelFreeze(values) {
     const {  rest, translate, history, setFlashMessage } = this.props;
     const ProductId = rest.computedMatch.params.userProductId;
     products.deleteFreeze(ProductId)
     .then(res => {
       setFlashMessage(`${translate('changes-saved-successfully')}`, true)
       history.goBack();
     })
     .catch((error) => {
       if (error.status === 401) {
         Auth.logOut();
         return
       } else if (error.body.errors[0]) {
         this.props.setFlashMessage("error", false)
         if (error.body.errors[0]) {
           if ( error.body.errors[0].code) {
             this.props.setFlashMessage(error.body.errors[0].code, false)
           }
         }
       }
     })

    }
  render() {
    return (
      <div>
        <FreezeForm onSubmit={this.handleSubmit.bind(this)} cancel={this.cancel.bind(this)} cancelFreeze={this.cancelFreeze.bind(this)} rest={this.props.rest}/>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    user: state.User.user,
    userID: state.User.id,
    freeze: state.Freeze,

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
  }
}

FreezeFormHandler = connect(
  mapStateToProps,
  mapDispatchToProps
)(FreezeFormHandler);


FreezeFormHandler = withRouter(FreezeFormHandler);
export default FreezeFormHandler;
// {`${translate('confirmation-freeze-message')} ?`}



// WEBPACK FOOTER //
// ./src/components/Freeze/FreezeForm.js